import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LegalTerms = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">Términos de Uso</h1>
          
          <div className="prose prose-invert prose-slate max-w-none">
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8 space-y-8 text-slate-300">
              
              <p className="text-slate-400 italic">
                Última actualización: Diciembre 2025
              </p>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">1. Aceptación de los Términos</h2>
                <p>
                  Al acceder y utilizar el sitio web de Blox (blox.com.py) y el lenguaje de programación Blox, 
                  usted acepta cumplir con estos términos de uso y la licencia CC BY-NC-SA 4.0 bajo la cual
                  se distribuye el software.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">2. Sobre BLOX</h2>
                <p className="mb-4">
                  BLOX es un lenguaje de programación diseñado íntegramente en español para enseñar
                  lógica, algoritmia y pensamiento computacional de manera clara, accesible y moderna.
                  Su sintaxis simple, sus estructuras intuitivas y su enfoque pedagógico lo convierten
                  en una herramienta ideal para estudiantes, docentes e instituciones educativas.
                </p>
                <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
                  <p className="text-cyan-300 font-semibold">🎯 Objetivo</p>
                  <p className="text-slate-400 mt-2">
                    Facilitar el aprendizaje de la programación sin barreras de idioma ni complejidad
                    innecesaria, ofreciendo un entorno amigable y librerías listas para usar desde el
                    primer programa.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">3. Características del Software</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Sintaxis completamente en español</li>
                  <li>Intérprete liviano, portable y fácil de instalar</li>
                  <li>Librerías básicas incluidas: <span className="text-cyan-400">strings, vectores, matrices, tablas, fechas, archivos</span></li>
                  <li>Ejemplos y documentación para comenzar rápidamente</li>
                  <li>Ecosistema en expansión con APIs avanzadas</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">4. Uso Permitido</h2>
                <p className="mb-4">BLOX puede utilizarse libremente para:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Uso personal y educativo</li>
                  <li>Desarrollo de proyectos académicos</li>
                  <li>Aprendizaje de programación</li>
                  <li>Investigación</li>
                  <li>Uso en instituciones educativas (sin fines comerciales)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">5. Restricciones</h2>
                <p className="mb-4">Queda prohibido sin autorización expresa:</p>
                <ul className="list-disc pl-6 space-y-2 text-slate-400">
                  <li>Uso comercial del software</li>
                  <li>Redistribución del intérprete sin atribución</li>
                  <li>Eliminación de créditos o avisos de autoría</li>
                  <li>Uso de las APIs premium sin licencia comercial</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">6. APIs y Contenido Premium</h2>
                <p>
                  BLOX cuenta con módulos opcionales que amplían su alcance hacia aplicaciones reales
                  (comunicación por sockets, web scraping, inteligencia artificial, redes neuronales,
                  distribuciones estadísticas, etc.). Estas APIs se distribuyen por separado con 
                  licencia comercial y no están cubiertas por estos términos de uso generales.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">7. Limitación de Responsabilidad</h2>
                <p>
                  BLOX se proporciona "TAL CUAL" sin garantías de ningún tipo. 
                  No nos hacemos responsables por daños derivados del uso del software.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">8. Autor</h2>
                <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
                  <p className="text-white font-semibold">Carlos J. Melgarejo</p>
                  <p className="text-slate-400 mt-1">
                    Ingeniero Electrónico – Universidad Nacional de Asunción (UNA).
                  </p>
                  <p className="text-slate-400 mt-2 text-sm">
                    Involucrado con la informática y la educación desde 1980: sistemas de comunicación,
                    drivers, IA, redes, bases de datos y diseño de lenguajes. BLOX es su proyecto más
                    reciente enfocado en educación.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">9. Contacto</h2>
                <p>
                  Para consultas sobre estos términos o uso comercial: {' '}
                  <a href="mailto:blox.com.py@gmail.com" className="text-cyan-400 hover:text-cyan-300">
                    blox.com.py@gmail.com
                  </a>
                </p>
              </section>

              <section className="border-t border-slate-700 pt-6">
                <p className="text-slate-400 text-sm">
                  Para información detallada sobre la licencia, consulte la página de {' '}
                  <a href="/legal/license" className="text-cyan-400 hover:text-cyan-300">Licencia</a>.
                </p>
              </section>

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalTerms;
